jq(document).ready(function() {
    
    jq('.bootstrap-select .dropdown-menu li').each(function(){
        jq(this).attr('role', 'menuitem');
    });
    
    // Current language select dropdown
    jq('select.select__current-language').on('change', function(e) {
        var langPrefix = jq(e.currentTarget).find('option:selected').val();
        var cleanedPrefix = langPrefix.replace(/[^0-9A-Za-z_]/g, '');
        location.href = '/'.concat(cleanedPrefix);
    });
    
});

var newsSlider = jq('.image-slider');
if (newsSlider.length) {
    newsSlider.slick({
      infinite: true,
      dots: true,
      arrows: false,
      appendDots: '.image-controls', 
      slidesToShow: 1,
      slidesToScroll: 1
    });    
}

var pubsYearFilter = jq('#publications-year-filter');
if (pubsYearFilter.length) {
    pubsYearFilter.on('change', function() {
        console.log('Changed!');
        jq('.module-publications .content-box').removeClass('hide');
        var year = jq(this).val();
        if (year == '-1') {
            return;    
        }
        jq('.module-publications .content-box').each(function() {
            var box = jq(this);
            var boxYear = box.data('year');
            if (boxYear != year) {
                box.addClass('hide');    
            }
        });
    });
}
function update(ID) {
    var select = document.getElementById('doc-language-' + ID);
    var doc_link = select.options[select.selectedIndex].getAttribute('data-file-path');
    var id = select.options[select.selectedIndex].getAttribute('data-doc-id');
    var button = document.getElementById('doc-btn-' + id);
        
    button.href = doc_link
}